export const ricercaIscrizioneSelector = (state) => state.anagrafe.ricercaIscrizione;

export const ricercaComuniSelector = (state) => state.anagrafe.ricercaComuni;